import { render } from "./RecursosAdmin.vue?vue&type=template&id=761efa7b&scoped=true"
import script from "./RecursosAdmin.vue?vue&type=script&lang=js"
export * from "./RecursosAdmin.vue?vue&type=script&lang=js"

import "./RecursosAdmin.vue?vue&type=style&index=0&id=761efa7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-761efa7b"]])

export default __exports__